// Styled components for AdvanceFilter UI
// This file defines styled layout and UI primitives for the AdvanceFilter component using Stitches.

import { styled } from "@stitches/react";

/**
 * Wrapper
 * Main container for the AdvanceFilter component, arranges content vertically with spacing.
 */
export const Wrapper = styled("div", {
  display: "flex",
  flexDirection: "column",
  gap: 16,
});

/**
 * Content
 * Horizontal flex container for the left and right filter panels.
 */
export const Content = styled("div", {
  display: "flex",
});

/**
 * CTA
 * Container for the call-to-action button, aligns it to the right.
 */
export const CTA = styled("div", {
  display: "flex",
  flexDirection: "row-reverse",
});

/**
 * LeftPanel
 * Panel for the filter options and search, scrollable if content overflows.
 */
export const LeftPanel = styled("div", {
  width: "50%",
  borderRight: "1px solid  #B6B7B7",
  maxHeight: 320,
  overflowY: "scroll",
});

/**
 * Search
 * Container for the search input and unselect button, with spacing and icon positioning.
 */
export const Search = styled("div", {
  display: "flex",
  gap: 16,
  marginBottom: 16,

  // Position the search icon inside the input
  "& svg": {
    position: "absolute",
    top: 8,
    left: 8,
  },
  // Set a fixed width for the button
  "& > button": {
    width: 160,
  },
});

/**
 * RightPanel
 * Panel for the selected summary and tags, scrollable if content overflows.
 */
export const RightPanel = styled("div", {
  width: "50%",
  paddingLeft: 8,
  maxHeight: 320,
  overflowY: "scroll",
});

/**
 * Summary
 * Displays the count of selected items and a clear button, with bold styling for the count.
 */
export const Summary = styled("div", {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: 16,
  "& > span": {
    fontWeight: "bold",
  },
});

/**
 * Tags
 * Container for removable tags representing selected filter options, wraps if too many.
 */
export const Tags = styled("div", {
  display: "flex",
  gap: 8,
  flexWrap: "wrap",
});
